import { cn } from '@/lib/utils'
import type { SegmentedControlProps } from './SegmentedControl.types'

export const SEGMENTED_CONTROL_CLASS =
  'inline-flex h-9 items-center gap-0.5 rounded-full border border-input bg-muted/60 p-0.5 text-sm shadow-inner'

export function SegmentedControl({
  children,
  label,
  className,
}: SegmentedControlProps) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn(SEGMENTED_CONTROL_CLASS, className)}
    >
      {children}
    </div>
  )
}
